import React, { useCallback, useEffect, useRef, useState } from "react"

const DropdownContext = React.createContext()

function useDropdownContext() {
    const context = React.useContext(DropdownContext)
    if (!context) {
        throw new Error(
            `Dropdown compound components cannot be rendered outside the Dropdown component`,
        )
    }
    return context
}

export const Dropdown = ({ children, toggleOnHover = false }) => {
    const [showMenu, setShowMenu] = useState(false);

    const openMenu = useCallback(() => {
        setShowMenu(true)
    }, [setShowMenu])
    const closeMenu = useCallback(() => setShowMenu(false), [setShowMenu])
    const targetRef = useRef()

    return (
        <div
            style={{
                display: "contents"
            }}
            onMouseEnter={() => toggleOnHover && openMenu()}
            onMouseLeave={() => toggleOnHover && closeMenu()}
        >
            <DropdownContext.Provider value={{ showMenu, openMenu, closeMenu, toggleOnHover, targetRef }}>
                <span ref={targetRef} className="position-relative">
                    {children}
                </span>
            </DropdownContext.Provider>
        </div>
    )
}

export const DropdownButton = ({ children }) => {
    const { showMenu, openMenu, closeMenu, toggleOnHover } = useDropdownContext()

    const toggleDropdown = () => {
        if (!toggleOnHover) {
            showMenu ? closeMenu() : openMenu()
        }
    }

    return (
        <div
            onClick={toggleDropdown}
            className={"cursor-pointer text-hover-primary"}
        >
            {children}
        </div>
    )
}

export const DropdownMenu = ({ children, offsetY = 4, anchorRight = false }) => {
    const { showMenu, targetRef, toggleOnHover, closeMenu } = useDropdownContext()

    const handleClickOutside = useCallback((event) => {
        if (targetRef.current && !targetRef.current.contains(event.target)) {
            closeMenu();
        }
    }, [targetRef, closeMenu])

    // Drop down Auto Hide Manager
    useEffect(_ => {
        if (!toggleOnHover) {
            if (showMenu) {
                document.addEventListener("click", handleClickOutside);
            }
            else {
                document.removeEventListener("click", handleClickOutside);
            }
        }

        return _ => document.removeEventListener("click", handleClickOutside)
    }, [showMenu, closeMenu, toggleOnHover, handleClickOutside]);

    return (
        showMenu && <div
            style={{
                position: "absolute",
                paddingTop: offsetY,
                top: "100%",
                ...anchorRight ? { right: 0 } : { left: 0 },
                zIndex: 20
            }}
        >
            {children}
        </div>
    )
}

Dropdown.Button = DropdownButton
Dropdown.Menu = DropdownMenu